// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"60":"c0513afb7f104e9c","408":"4059567de4793159","439":"702ea4eca7ba62b1"}[chunkId] + ".js";
};